import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "./HeroSectionVVB";
// import Flow from './Flow'
import Navigation from "../../Navbar";
import About from "./AboutVVB";
import BenefitVVB from "./Benefit";
import Service from "./Service";
import FlowService from "./FlowService";
import Commitment from "./Commitment";
import AppealFlow from "./AppealFlow";
// import ContactUsService from "./ServiceContactUs";
// import Import from './Import';
// import Desc from './Desc';
import ContactUs from "../tkdn/ContactUs";

function VVB() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const contactUs = [
    {
      name: "Halija Syuchah",
      email: "halija.syuchah@anindya.biz",
      phone: "+62 851-2104-4449",
    },
    {
      name: "⁠Ramazan Sofiano",
      email: "ramazan.bs@anindya.biz",
      phone: "+62 813-1188-0439",
    },
  ];

  return (
    <>
      <Navigation />
      <HeroSection />
      <About />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <BenefitVVB />
      </div>
      <Service />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <FlowService />
      </div>
      <Commitment />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <AppealFlow />
      </div>
      {/* <ContactUsService /> */}
      <ContactUs data={contactUs} sectionTitle={"contact_title"} />
    </>
  );
}

export default VVB;
